import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import Viewer from '../pdfViewer/Viewer';

import { ILocation, ISkleraItem } from '../utils/interface';
import { Context } from '../MunicipalNoticeBoard';
import { prepDate, sortCategory } from '../utils/helpers';
import { Button, ListCategoryButton, ListInfo, ListItem } from './StyledComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faFile } from '@fortawesome/free-solid-svg-icons';
import { CategoryIcon } from './Icon';

import { skleraSDK } from '@sklera/sdk';
import { HumanReadableDate } from '../utils/HumanReadableDate';

const List = () => {
    const [activeFilter, setActiveFilter] = useState<string | null>(null);
    const [selectedItem, setSelectedItem] = useState<ISkleraItem | null>(null);

    const { allFolders, icons, mainFolder, hideEmptyPlaylistSwitch, allDocuments, font } = useContext(Context);

    const location = useLocation<{ categoryId: string }>();
    const history = useHistory();
    const { categoryId } = location.state;
    const fontFamily = font ? { fontFamily: font } : {};

    const category = allFolders?.get(categoryId);

    const iconPath = category?.iconId && icons?.get(category?.iconId)?.url;
    const {
        name = 'Alle Dokumente',
        children = mainFolder?.children
            .filter((f) => !hideEmptyPlaylistSwitch || f.countDocuments)
            .sort(sortCategory) || [],
    } = category || {};

    const filteredDocuments =
        allDocuments?.filter((d) => {
            if (activeFilter) {
                if (category) {
                    return d.subCategoryId === activeFilter;
                } else {
                    return d.categoryId === activeFilter;
                }
            }
            if (category) {
                return d.categoryId === categoryId;
            }
            return !!d.categoryId;
        }) || [];

    const goBackHome = () => history.push({ pathname: '/', search: location.search });

    function closePdfViewer(): void {
        setSelectedItem(null);
    }

    function displayInfo(): JSX.Element {
        // let filter = createFilter(children);
        return (
            <div>
                <div className="header">
                    {categoryId ? <CategoryIcon src={iconPath} style={{ width: '3em', height: '3em' }} /> : ''}
                    <h1 style={fontFamily}>{name}</h1>
                </div>

                <div className={children?.length > 0 ? 'filters' : ''}>
                    <div style={fontFamily}>
                        {' '}
                        {categoryId ? 'Nach Unterkategorie filtern:' : 'Nach Kategorie filtern:'}
                    </div>
                    {children?.sort(sortCategory).map((cat) => {
                        const { _id, name } = cat;
                        const isSelected = _id === activeFilter;
                        return (
                            <ListCategoryButton
                                key={_id}
                                selected={isSelected}
                                onClick={() => setActiveFilter(isSelected ? null : _id)}
                                style={fontFamily}
                            >
                                {cat.iconId && icons?.has(cat.iconId) ? (
                                    <CategoryIcon
                                        src={icons?.get(cat.iconId)?.url}
                                        style={{
                                            width: '1.3em',
                                            height: '0.9em',
                                            display: 'inline-block',
                                        }}
                                    />
                                ) : (
                                    ''
                                )}{' '}
                                {name}
                            </ListCategoryButton>
                        );
                    })}
                </div>
            </div>
        );
    }

    function displayList() {
        return (
            <div>
                {filteredDocuments.map((item) => {
                    const { name, _id, data } = item;
                    return (
                        <ListItem
                            className="item"
                            key={_id}
                            onClick={() =>
                                getItemData({
                                    name,
                                    _id,
                                    description: data?.description || null,
                                })
                            }
                            style={window.innerWidth < 700 ? { padding: '0.5rem' } : {}}>
                            <FontAwesomeIcon icon={faFile} />
                            <div>
                                <h2 style={fontFamily}>{name}</h2>
                                <p style={fontFamily}>
                                    <HumanReadableDate
                                        validFrom={item.validFrom}
                                        validTo={item.validTo}></HumanReadableDate>
                                </p>
                            </div>
                        </ListItem>
                    );
                })}
                {filteredDocuments.length === 0 ? (
                    <div className="item">
                        <h2 style={{ color: '#e0e0e0', ...fontFamily }}>Keine Dokumente vorhanden</h2>
                        <div className="divider" />
                    </div>
                ) : null}
            </div>
        );
    }

    const getItemData = async ({
        name,
        _id,
        description,
    }: {
        name: string;
        _id: string;
        description: string | null;
    }) => {
        console.log('GET ITEM DATA');
        await skleraSDK
            .getItemData(_id)
            .then((item: ISkleraItem) => {
                console.log('item data found', item);
                setSelectedItem({ ...item, name: name, description: description, _id });
            })
            .catch((e: any) => {
                console.log('FEHLER', e);
            });
    };

    return (
        <div className="view">
            <Button onClick={goBackHome} style={font ? { fontFamily: font } : {}}>
                <FontAwesomeIcon icon={faAngleLeft} style={{ marginRight: '0.5em' }} />
                Zurück
            </Button>
            <div className="row">
                <ListInfo className="info">{displayInfo()}</ListInfo>
                <div className="list">{displayList()}</div>
            </div>
            {selectedItem ? (
                <div className="pdf-viewer-modal">
                    <Viewer selectedItem={selectedItem} closePdfViewer={closePdfViewer} />
                </div>
            ) : null}
        </div>
    );
};

export default List;
